import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';
 

export default function Footer() {
  const companyLinks = [
    { id: 'footer_about', label: 'About Us', href: '/about' },
    { id: 'footer_history', label: 'Our History', href: '/about#history' },
    { id: 'footer_certifications', label: 'Certifications', href: '/about#certifications' },
    { id: 'footer_careers', label: 'Careers', href: '/contact' },
  ]

  const productLinks = [
    { id: 'footer_cooking_oils', label: 'Cooking Oils', href: '/products#cooking-oils' },
    { id: 'footer_wood_pellets', label: 'Wood Pellets', href: '/products#wood-pellets' },
    { id: 'footer_chicken_feed', label: 'Chicken Feed', href: '/products#chicken-feed' },
    { id: 'footer_fertilizers', label: 'Fertilizers', href: '/products#fertilizers' },
    { id: 'footer_iron_scraps', label: 'Iron Scraps', href: '/products#iron-scraps' },
    { id: 'footer_whey_proteins', label: 'Whey Proteins', href: '/products#whey-proteins' },
    { id: 'footer_animal_feeds', label: 'Animal Feeds', href: '/products#animal-feeds' },
    { id: 'footer_copper_scraps', label: 'Copper Scraps', href: '/products#copper-scraps' },
    { id: 'footer_copy_papers', label: 'Copy Papers', href: '/products#copy-papers' },
    { id: 'footer_thailand_truck_tires', label: 'Thailand Truck Tires', href: '/products#truck-tires' },
  ]

  const legalLinks = [
    { id: 'footer_privacy', label: 'Privacy Policy', href: '/privacy' },
    { id: 'footer_terms', label: 'Terms of Service', href: '/terms' },
    { id: 'footer_faq', label: 'FAQ', href: '/faq' },
    { id: 'footer_contact', label: 'Contact', href: '/contact' },
    { id: 'footer_blog', label: 'Blog', href: '/blog' },
  ]

  const socialLinks = [
    { id: 'social_linkedin', icon: 'BuildingOffice2Icon', href: '#', label: 'LinkedIn' },
    { id: 'social_facebook', icon: 'UserGroupIcon', href: '#', label: 'Facebook' },
    { id: 'social_twitter', icon: 'ChatBubbleLeftRightIcon', href: '#', label: 'Twitter' },
  ]

  return (
    <footer className="bg-gray-900 text-white rounded-t-organic-xl mt-12 relative overflow-hidden">
      {/* Top Gradient Decoration */}
      <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />

      <div className="max-w-container mx-auto px-6 md:px-12 py-16">
        {/* Row 1: Link Groups */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 pb-12 border-b border-white/10">
          {/* Company Links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Company</h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-gray-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Products</h3>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-gray-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Support Links */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Legal & Support</h3>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.id}>
                  <Link
                    href={link.href}
                    className="text-sm text-gray-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Row 2: Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Copyright & Contact */}
          <div className="flex flex-col md:flex-row items-center gap-4 text-sm text-gray-400">
            <span>© 2026 Supplies Distributors SA. All rights reserved.</span>
            <span className="hidden md:inline">|</span>
            <span>VAT: BE0475286142</span>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.href}
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-400 hover:text-white hover:border-white/40 transition-colors"
                aria-label={social.label}
              >
                <Icon name={social.icon as any} size={18} />
              </a>
            ))}
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-end gap-1 text-xs text-gray-400">
            <span>info@suppliesdistributorssa.com</span>
            <span>Rue du Trilogiport 6, 4681 Oupeye, Belgium</span>
          </div>
        </div>

        {/* Partner Trust Badges */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500">
            <div className="text-gray-500 text-xs font-semibold uppercase tracking-widest">ISO Certified</div>
            <div className="text-gray-500 text-xs font-semibold uppercase tracking-widest">Quality Standards</div>
            <div className="text-gray-500 text-xs font-semibold uppercase tracking-widest">Global Shipping</div>
            <div className="text-gray-500 text-xs font-semibold uppercase tracking-widest">Trusted Partner</div>
          </div>
        </div>
      </div>
    </footer>
  )
}